import { useParams, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Smart route for logyra.fr/:slug
 * Checks if the slug is a valid enseigne, then redirects to /employee/auth/:slug
 */
export function EnseigneEmployeeRoute() {
  const { enseigneSlug } = useParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/v2/enseigne-by-slug/${enseigneSlug}`)
      .then(() => setStatus('valid'))
      .catch(() => setStatus('invalid'));
  }, [enseigneSlug]);

  if (status === 'loading') return null;
  if (status === 'invalid') return <Navigate to="/" replace />;
  return <Navigate to={`/employee/auth/${enseigneSlug}`} replace />;
}

/**
 * Smart route for logyra.fr/:slug/admin
 */
export function EnseigneAdminRoute() {
  const { enseigneSlug } = useParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/v2/enseigne-by-slug/${enseigneSlug}`)
      .then(() => setStatus('valid'))
      .catch(() => setStatus('invalid'));
  }, [enseigneSlug]);

  if (status === 'loading') return null;
  if (status === 'invalid') return <Navigate to="/" replace />;
  return <Navigate to={`/admin/login/${enseigneSlug}`} replace />;
}
